import { FC } from 'react';

type Props = {
	step: number;
	maxSteps?: number;
};

const NotificationCreateChart: FC<Props> = ({ step, maxSteps }) => {
	const radius = 16;
	const stroke = 5;
	const normalizedRadius = radius - stroke / 2;
	const circumference = normalizedRadius * 2 * Math.PI;
	const progress = maxSteps ? step / maxSteps : 1;
	const strokeDashoffset = circumference - progress * circumference;

	return (
		<div className='relative flex items-center justify-center'>
			<svg
				height={radius * 2}
				width={radius * 2}
        fill='transparent'
				className='rotate-[90deg]'>
				<circle
					stroke='#EAEAEA'
					fill='inherit'
					strokeWidth={stroke}
					r={normalizedRadius}
					cx={radius}
					cy={radius}
				/>
				{maxSteps && (
					<circle
						stroke="var(--color-primary-color)"
						fill='inherit'
						strokeWidth={stroke}
						strokeLinecap='round'
						strokeDasharray={circumference + ' ' + circumference}
						strokeDashoffset={strokeDashoffset}
						r={normalizedRadius}
						cx={radius}
						cy={radius}
					/>
				)}
			</svg>			
		</div>
	);
};

export default NotificationCreateChart;
